/**
 * Before|After 비교의 축 하나. 도메인 값을 문자열 두 개로 바꾸는 순수 코어다.
 *
 * 공통 configuration 의 정보·설정 축이 같은 비교 표현을 쓴다.
 *
 * Owns: 축 shape · 변경 여부 판정 · 빈 값 표시.
 * Does not own: 어떤 축이 있는지(각 도메인의 diff 함수) · 렌더(`DiffView`).
 */

// 값이 없는 축의 표시. 빈 문자열을 그대로 두면 "→" 만 남아 무엇이 바뀌었는지 알 수 없다.
export const DIFF_EMPTY = "—";

export type DiffAxis = {
  axis: string;
  before: string;
  after: string;
  changed: boolean;
};

/** 축 하나. 변경 여부는 표시 문자열의 일치로만 정한다. 화면에서 같게 보이면 바뀌지 않은 것이다. */
export function axis(name: string, before: string, after: string): DiffAxis {
  return { axis: name, before, after, changed: before !== after };
}

/** 바뀐 축만 반환한다. 변경 요약은 이 축만 그린다. */
export function changedAxes(axes: readonly DiffAxis[]): readonly DiffAxis[] {
  return axes.filter((entry) => entry.changed);
}
